const ACTION = {
  UPDATE_DATA: 'UPDATE_DATA',
  UPDATE_IS_FETCHING_DATA: 'UPDATE_IS_FETCHING_DATA',
};

const INIT_STATE = {
  data: {},
  isFetchingData: false,
};

const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case ACTION.UPDATE_DATA: {
      const { data } = payload;

      return {
        ...state,
        data: {
          ...state.data,
          ...data,
        },
      };
    }
    case ACTION.UPDATE_IS_FETCHING_DATA: {
      const { isFetchingData } = payload;

      return {
        ...state,
        isFetchingData,
      };
    }
    default: {
      return state;
    }
  }
};

export { ACTION, INIT_STATE };

export default reducer;
